<template lang="pug">
	.main-menu(v-if="Publisher.SelectedPublisher")
		.menu-item.playables(v-if="_.get(Publisher, 'SelectedPublisher.options.mainMenu.playables') !== false" :class="{active: Layout.page === 'playables'}" @click="Layout.setPage('playables')")
			.item-title Playables
		.menu-item.banners(v-if="Metadata.Config['feature-banners'] && _.get(Publisher, 'SelectedPublisher.options.mainMenu.banners') !== false" :class="{active: Layout.page === 'banners'}" @click="Layout.setPage('banners')")
			.item-title Banners
		.menu-item.marker(v-for="(enabled, marker) in _.get(Publisher, 'SelectedPublisher.options.mainMenu.markers')" v-if="Publisher.SelectedPublisher.options.projectMarkers[marker] && enabled" :class="{active: Layout.page === 'marker' && Layout.pageOptions.markers[0] === marker}" @click="Layout.setPage('marker', {markers: [marker]})")
			.item-title {{marker}}
		.menu-item.banners(v-if="Metadata.Config['feature-end-cards'] && _.get(Publisher, 'SelectedPublisher.options.mainMenu.endCards') !== false" :class="{active: Layout.page === 'end-cards'}" @click="Layout.setPage('end-cards')")
			.item-title End Cards
		.menu-item.storyboards(v-if="Metadata.Config['feature-storyboards'] && _.get(Publisher, 'SelectedPublisher.options.mainMenu.storyboards') !== false" :class="{active: Layout.page === 'storyboards'}" @click="Layout.setPage('storyboards')")
			.item-title Storyboards
		.menu-item.editable-playables(v-if="Metadata.Config['feature-editable-playables'] && _.get(Publisher, 'SelectedPublisher.options.mainMenu.editablePlayables') !== false" :class="{active: Layout.page === 'editable-playables'}" @click="Layout.setPage('editable-playables')")
			.item-title AI Playables
	</template>

<script>

	import Screen 			from './../../mixins/screen'

	export default {
		name: "OnlineUsersHeader",
		mixins: [Screen],
		screen: {
			updateOn: ["Layout Page Changed", "Metadata Loaded", "Selected Publisher Changed", "Selected Publisher Data Changed"]
		},
		data() {

			return {
				showed: true
			}
		},
		methods: {
			collectData() {

			}
		}
	}
</script>

<style lang="sass" scoped>

	.main-menu
		display: flex
		flex-direction: row
		justify-content: center
		align-content: center
		margin-left: 10px
		user-select: none

		.menu-item
			display: flex
			justify-content: center
			align-items: center
			margin: 0 0
			cursor: pointer
			border: 1px solid transparent
			border-radius: 0.25rem

			.item-title
				padding: 0.2rem 1rem
				color: rgba(255, 255, 255, 0.65)

			&:hover

				.item-title
					color: rgba(255, 255, 255, 1)

			&.active
				border: 1px solid var(--green)

				.item-title
					color: #5bff94


</style>

